import { render, staticRenderFns } from "./SortableHighlightedOffers.vue?vue&type=template&id=a1b94a58"
import script from "./SortableHighlightedOffers.vue?vue&type=script&lang=js"
export * from "./SortableHighlightedOffers.vue?vue&type=script&lang=js"
import style0 from "./SortableHighlightedOffers.vue?vue&type=style&index=0&id=a1b94a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports